export default "__VITE_ASSET__BZJo8HrO__"